import api from "./api";

//const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/employee-posting`,payload);
export const postingEmployees=async(payload)=>{
    await api.post(`/api/employee-posting`,payload);

};

export const getVerifiedEmployeesForPosting= async()=>{
    const response = await api.get(`/api/documents-verification/status/ACTIVE`);
    return response.data;
};

export  const fetchLocations=async(postingDistrict,postingProject)=>{
    const response= await api.get(`/api/locations/by-district/${postingDistrict}/${postingProject}`);
    return response.data;
}